import { Routes, Route } from "react-router-dom"; // Remove BrowserRouter
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Services from "./components/Services";
import Contact from "./components/Contact";
import QuienesSomos from "./components/Somos2";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: "Merriweather", serif;
    color: #e5e5e5;
    background-color: #121212;
    margin: 0;
    padding: 0;
  }

  h1, h2, h3 {
    font-family: "Georgia", serif;
    color: #d4af37;
    text-transform: uppercase;
  }

  p {
    font-family: "Merriweather", serif;
    line-height: 1.7;
  }
`;

const About = () => <h1>About Us</h1>;

function App() {
  return (
    <>
      <GlobalStyle />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quienessomos" element={<QuienesSomos />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
